var _creatorTabsConfig, _sortMetricsConfig, _SORT_BY_MAP, _SORT_MODE_MAP, _SortMarketPlaceTrack;
import { i18n } from '@ecom-alliance/libs';
import { AffiliateCreatorProfileSortingAlgorithm, ContentPreferenceType, CreatorSortField, SortOrder } from '@/api/affiliate/serv/oec_affiliate_creator_marketplace_api';
import { CreatorMarketplaceClickForEnum } from '../track';
export var MAX_REQUEST_TIMES = 5;
export var MAX_TOTAL_CREATORS_NUMBER = 2000;
export var MIN_SINGLE_REQUEST_CREATORS_NUMBER = 12;
export var LOCAL_STORE_LIST_MODE_KEY = 'find-creators-list-mode';
export var CreatorListFilterEnum = /*#__PURE__*/function (CreatorListFilterEnum) {
  CreatorListFilterEnum["ProductCategory"] = "productCategory";
  CreatorListFilterEnum["CreatorScore"] = "creatorScore";
  CreatorListFilterEnum["ContentType"] = "contentType";
  CreatorListFilterEnum["Followers"] = "followerCount";
  CreatorListFilterEnum["FollowerAge"] = "followerAgeGroup";
  CreatorListFilterEnum["FollowerGender"] = "followerGender";
  CreatorListFilterEnum["OtherFilter"] = "otherFilter";
  CreatorListFilterEnum["ManagedByAgency"] = "managedByAgency";
  return CreatorListFilterEnum;
}({});
export var CreatorListViewModeEnum = /*#__PURE__*/function (CreatorListViewModeEnum) {
  CreatorListViewModeEnum["Card"] = "card_view";
  CreatorListViewModeEnum["Table"] = "list_view";
  return CreatorListViewModeEnum;
}({});
export var PageStatusEnum = /*#__PURE__*/function (PageStatusEnum) {
  PageStatusEnum["Init"] = "init";
  PageStatusEnum["Empty"] = "empty";
  PageStatusEnum["Success"] = "success";
  PageStatusEnum["Loading"] = "loading";
  PageStatusEnum["ServerError"] = "server_error";
  PageStatusEnum["NetworkError"] = "network_error";
  return PageStatusEnum;
}({});
export var SortByEnum = /*#__PURE__*/function (SortByEnum) {
  SortByEnum["DEFAULT"] = "Default";
  SortByEnum["FOLLOWERS"] = "Followers";
  SortByEnum["LIVESTREAM"] = "Livestream Watch UV";
  SortByEnum["VIDEO"] = "Video views";
  SortByEnum["LIVE_GPM"] = "LIVE GPM";
  SortByEnum["VIDEO_GPM"] = "Video GPM";
  return SortByEnum;
}({});
export var BooleanValue = /*#__PURE__*/function (BooleanValue) {
  BooleanValue["TRUE"] = "true";
  BooleanValue["FALSE"] = "false";
  return BooleanValue;
}({});
export var SortModeEnum = /*#__PURE__*/function (SortModeEnum) {
  SortModeEnum["DEFAULT"] = "default";
  SortModeEnum["DESCEND"] = "descend";
  SortModeEnum["ASCEND"] = "ascend";
  return SortModeEnum;
}({});
export var CreatorListTabsEnum = /*#__PURE__*/function (CreatorListTabsEnum) {
  CreatorListTabsEnum["ALL"] = "all_creators";
  CreatorListTabsEnum["VIDEO"] = "video_creators";
  CreatorListTabsEnum["LIVE"] = "live_creators";
  return CreatorListTabsEnum;
}({});
export var creatorTabsConfig = (_creatorTabsConfig = {}, _creatorTabsConfig[CreatorListTabsEnum.ALL] = {
  sortOptions: [SortByEnum.DEFAULT, SortByEnum.FOLLOWERS, SortByEnum.VIDEO, SortByEnum.LIVESTREAM],
  getTitle: function getTitle() {
    return i18n.t('affiliate_marketplace_all_creators_title', 'All');
  }
}, _creatorTabsConfig[CreatorListTabsEnum.VIDEO] = {
  contentType: ContentPreferenceType.VIDEO,
  sortOptions: [SortByEnum.DEFAULT, SortByEnum.FOLLOWERS, SortByEnum.VIDEO, SortByEnum.VIDEO_GPM],
  helpTrackName: 'video_creators_tab',
  getTitle: function getTitle() {
    return i18n.t('affiliate_marketplace_video_creators_title', 'Video creators');
  },
  getHelp: function getHelp() {
    return i18n.t('affiliate_marketplace_video_creators_tooltip', 'Creators whose short videos generated more GMV than their LIVE videos in the past 30 days.');
  }
}, _creatorTabsConfig[CreatorListTabsEnum.LIVE] = {
  contentType: ContentPreferenceType.LIVE,
  sortOptions: [SortByEnum.DEFAULT, SortByEnum.FOLLOWERS, SortByEnum.LIVESTREAM, SortByEnum.LIVE_GPM],
  helpTrackName: 'live_creators_tab',
  getTitle: function getTitle() {
    return i18n.t('affiliate_marketplace_live_creators_title', 'LIVE creators');
  },
  getHelp: function getHelp() {
    return i18n.t('affiliate_marketplace_live_creators_tooltip', 'Creators whose LIVE videos generated more GMV than their short videos in the past 30 days.');
  }
}, _creatorTabsConfig);
export var sortMetricsConfig = (_sortMetricsConfig = {}, _sortMetricsConfig[SortByEnum.DEFAULT] = {
  clickFor: CreatorMarketplaceClickForEnum.RelevanceSort,
  sortMode: SortModeEnum.DEFAULT,
  algorithm: AffiliateCreatorProfileSortingAlgorithm.AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_ALGO_RECOMMENDATION,
  i18nKey: 'affiliate_marketplace_creators_sortby_relevance',
  defaultText: 'Relevance'
}, _sortMetricsConfig[SortByEnum.FOLLOWERS] = {
  clickFor: CreatorMarketplaceClickForEnum.FollowersSort,
  sortMode: SortModeEnum.DESCEND,
  algorithm: AffiliateCreatorProfileSortingAlgorithm.AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_ALGO_FOLLOWER_CNT_DESCENDING,
  i18nKey: 'creator_marketplace_follower_plural',
  defaultText: 'Followers'
}, _sortMetricsConfig[SortByEnum.VIDEO] = {
  clickFor: CreatorMarketplaceClickForEnum.VideoViewSort,
  sortMode: SortModeEnum.DESCEND,
  algorithm: AffiliateCreatorProfileSortingAlgorithm.AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_ALGO_EC_VIDEO_AVG_VIEW_DESCENDING,
  i18nKey: 'affiliate_find_creator_homepage_core_data_ec_video_vv',
  defaultText: 'Avg. video views',
  helpTrackName: 'video_views',
  getHelp: function getHelp() {
    return i18n.t('affiliate_find_creator_homepage_core_data_ec_video_vv_description', "The average number of views of this creator's product videos posted in the last 30 days");
  }
}, _sortMetricsConfig[SortByEnum.LIVESTREAM] = {
  clickFor: CreatorMarketplaceClickForEnum.LiveWatchUVSort,
  sortMode: SortModeEnum.DESCEND,
  algorithm: AffiliateCreatorProfileSortingAlgorithm.AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_ALGO_LIVE_AVG_VIEW_DESCENDING,
  i18nKey: 'affiliate_find_creator_livestream_watch_uv',
  defaultText: 'Avg. LIVE views',
  helpTrackName: 'live_viewers',
  getHelp: function getHelp() {
    return i18n.t('affiliate_find_creator_tooltip_live_watch_uv', "The average number of viewers of this creator's LIVE videos in the past 30 days.");
  }
}, _sortMetricsConfig[SortByEnum.VIDEO_GPM] = {
  clickFor: CreatorMarketplaceClickForEnum.LiveWatchUVSort,
  sortMode: SortModeEnum.DESCEND,
  algorithm: AffiliateCreatorProfileSortingAlgorithm.AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_VIDEO_GPM_DESCENDING,
  i18nKey: 'affiliate_find_creator_video_GPM',
  defaultText: 'Video GPM',
  helpTrackName: 'video_gpm',
  getHelp: function getHelp() {
    return i18n.t('affiliate_find_creator_tooltip_video_gpm', 'Video GMV per mille (GPM) represents the  GMV generated per 1000 short video views.');
  }
}, _sortMetricsConfig[SortByEnum.LIVE_GPM] = {
  clickFor: CreatorMarketplaceClickForEnum.LiveWatchUVSort,
  sortMode: SortModeEnum.DESCEND,
  algorithm: AffiliateCreatorProfileSortingAlgorithm.AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_LIVE_GPM_DESCENDING,
  i18nKey: 'affiliate_find_creator_live_gpm',
  defaultText: 'LIVE GPM',
  helpTrackName: 'live_gpm',
  getHelp: function getHelp() {
    return i18n.t('affiliate_find_creator_tooltip_live_gpm', 'LIVE GMV per mille (GPM) represents the GMV generated per 1000 LIVE video views.');
  }
}, _sortMetricsConfig);
export var SORT_BY_MAP = (_SORT_BY_MAP = {}, _SORT_BY_MAP[SortByEnum.DEFAULT] = CreatorSortField.DEFAULT, _SORT_BY_MAP[SortByEnum.FOLLOWERS] = CreatorSortField.FOLLOWERS_CNT, _SORT_BY_MAP[SortByEnum.VIDEO] = CreatorSortField.VIDEO_AVG_VIEW_CNT, _SORT_BY_MAP[SortByEnum.LIVESTREAM] = CreatorSortField.LIVE_WATCH_UV, _SORT_BY_MAP);
export var SORT_MODE_MAP = (_SORT_MODE_MAP = {}, _SORT_MODE_MAP[SortModeEnum.DEFAULT] = SortOrder.DESC, _SORT_MODE_MAP[SortModeEnum.ASCEND] = SortOrder.ASC, _SORT_MODE_MAP[SortModeEnum.DESCEND] = SortOrder.DESC, _SORT_MODE_MAP);
export var MAX_COLLECTION_CREATOR_LIST = 1000;
export var MAX_TARGET_INVITATION_CREATOR_LIST = 50;
export var SearchTypeEnum = /*#__PURE__*/function (SearchTypeEnum) {
  SearchTypeEnum["SEARCH"] = "search";
  SearchTypeEnum["SEARCH_SUGGESTION"] = "search_suggestion";
  return SearchTypeEnum;
}({});
export var TabEnum = /*#__PURE__*/function (TabEnum) {
  TabEnum["Creator"] = "creator";
  TabEnum["Follower"] = "follower";
  TabEnum["Performance"] = "performance";
  return TabEnum;
}({});
export var SortEnum = /*#__PURE__*/function (SortEnum) {
  SortEnum[SortEnum["Relevance"] = 0] = "Relevance";
  SortEnum[SortEnum["Revenue"] = 1] = "Revenue";
  SortEnum[SortEnum["UnitsSold"] = 2] = "UnitsSold";
  SortEnum[SortEnum["Follower"] = 3] = "Follower";
  SortEnum[SortEnum["VideoViews"] = 4] = "VideoViews";
  SortEnum[SortEnum["EngagementRate"] = 5] = "EngagementRate";
  return SortEnum;
}({});
export var SortMarketPlaceTrackConfig = (_SortMarketPlaceTrack = {}, _SortMarketPlaceTrack[AffiliateCreatorProfileSortingAlgorithm.AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_ALGO_RECOMMENDATION] = {
  eventTrackId: 'Relevancy_sort'
}, _SortMarketPlaceTrack[AffiliateCreatorProfileSortingAlgorithm.AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_GMV_REVENUE_DESCENDING] = {
  eventTrackId: 'GMV_sort'
}, _SortMarketPlaceTrack[AffiliateCreatorProfileSortingAlgorithm.AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_UNITS_SOLD_DESCENDING] = {
  eventTrackId: 'units_sold_sort'
}, _SortMarketPlaceTrack[AffiliateCreatorProfileSortingAlgorithm.AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_ALGO_FOLLOWER_CNT_V2_DESCENDING] = {
  eventTrackId: 'Followers_sort'
}, _SortMarketPlaceTrack[AffiliateCreatorProfileSortingAlgorithm.AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_ALGO_VIDEO_MED_VIEW_DESCENDING] = {
  eventTrackId: 'video_view_sort'
}, _SortMarketPlaceTrack[AffiliateCreatorProfileSortingAlgorithm.AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_AVG_ENGAGEMENT_RATE_DESCENDING] = {
  eventTrackId: 'engagement_rate_sort'
}, _SortMarketPlaceTrack);
export var OpenCrmEnterFromEnum = /*#__PURE__*/function (OpenCrmEnterFromEnum) {
  OpenCrmEnterFromEnum[OpenCrmEnterFromEnum["OTHER_SOURCE"] = 0] = "OTHER_SOURCE";
  OpenCrmEnterFromEnum[OpenCrmEnterFromEnum["FIND_CREATORS"] = 1] = "FIND_CREATORS";
  return OpenCrmEnterFromEnum;
}({});
export var MAX_SAVE_CRM_CREATOR_NUMBER = 5000;